import { TANDEM_HOMEPAGE_URL, TANDEM_PATIENTS_URL } from '../../constants';
import Button from 'design-system/src/components/Button/Button';

export type ReturnToHomePageButtonProps = {
  linkType?: 'patient' | 'provider';
  className?: string;
};

export const ReturnToHomePageButton = ({ linkType = 'provider', className }: ReturnToHomePageButtonProps) => {
  const url = linkType === 'patient' ? TANDEM_PATIENTS_URL : TANDEM_HOMEPAGE_URL;
  return (
    <Button href={url} className={className} width="full">
      Return to Tandem Homepage
    </Button>
  );
};
